import { Popover, Space, Tag } from 'antd'
import React from 'react'

function BalanceAuditTag(props) {
    return (
        <Popover content={
            <Space direction='vertical'>
                {props.eie_audit1_uname && <Tag color='green'>1级{props.eie_audit1_uname} {props.eie_audit1_ctime}</Tag>}
                {props.eie_audit2_uname && <Tag color='geekblue'>2级{props.eie_audit2_uname} {props.eie_audit2_ctime}</Tag>}
                {props.eie_audit3_uname && <Tag color='gold'>3级{props.eie_audit3_uname} {props.eie_audit3_ctime}</Tag>}
                {props.eie_audit4_uname && <Tag color='magenta'>4级{props.eie_audit4_uname} {props.eie_audit4_ctime}</Tag>}
            </Space>
        }>
            {(props.eie_audit1_uname &&  !props.eie_audit2_uname && !props.eie_audit3_uname && !props.eie_audit4_uname) && <Tag color='green'>1级{props.eie_audit1_uname}</Tag>}
            {(props.eie_audit2_uname &&  !props.eie_audit3_uname && !props.eie_audit4_uname) && <Tag color='geekblue'>2级{props.eie_audit2_uname}</Tag>}
            {(props.eie_audit3_uname &&  !props.eie_audit4_uname)&& <Tag color='gold'>3级{props.eie_audit3_uname}</Tag>}
            {props.eie_audit4_uname && <Tag color='magenta'>4级{props.eie_audit4_uname}</Tag>}
        </Popover>
    )
}

export default BalanceAuditTag